import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";

const Premium = () => {
  return (
    <StyledPremium>
      <strong className="name-formule"> 🚀 BOOST (PREMIUM)</strong>
      <span> 199.99 €</span>
      <ul>
        <li>🎉 Offre de bienvenue 140 €</li>
        <li>✅ 1 mois </li>
        <li>✅ Format image : Carré (1:1) || Formats acceptés : .jpg, .jpeg</li>
        <li>
          ✅ Format image : Horizontale (2:1) 1200px - 600px || Formats acceptés
          : .jpg, .jpeg
        </li>
        <li>✅ Taille maximale par image : 2 Mo </li>
        <li>✅ Emplacement : Business & Annonces </li>
        <li>
          🎁 Parrainage : 3 filleuls = -15% sur votre prochaine campagne (offre
          non cumulable avec l’engagement 3 mois)
        </li>
        <li>
          <strong>
            🔥 -35% sur 3 mois d’engagement (non cumulable avec l’offre de
            bienvenue ni avec la réduction parrainage)
          </strong>
        </li>
      </ul>
    </StyledPremium>
  );
};

export default Premium;
const StyledPremium = styled.div`
  background: ${COLORS.main};
  border: solid 2px ${COLORS.green};
  border-radius: 5px;
  color: white;
  padding: 10px;
  max-width: 23%;
  display: flex;
  flex-direction: column;
  .name-formule {
    display: block;
    font-size: 1.1em;
    text-align: center;
    color: ${COLORS.border_and_text_blue};
  }
  span {
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 1.2em;
    color: ${COLORS.orange_new};
    margin: 15px 0px;
  }
  ul {
    li {
      margin-top: 20px;
    }
  }
  @media screen and (max-width: 445px) {
    min-width: 85%;
    margin-bottom: 30px;
  }
`;
